import { useMemo } from 'react';
import { createPortal } from 'react-dom';

import { MessageList } from '../MessageList';

export const Messages = () => {
    const element = useMemo(() => document.getElementById('messages'), []);

    if (!element) {
        return null;
    }

    return createPortal(<MessageList />, element);
};
